import { string } from "prop-types";
import { useCallback } from "react";

import styled from "styled-components";

import FnrContainedIcon from "UI/FnrContainedIcon";

import externalNavigate from "Utilities/externalNavigate";

import { ButtonWrapper } from "./shared";

const ButtonDisplay = ({ color }) => (
  <FnrContainedIcon color={color} size="xl" icon="fa-question-circle fas" />
);

ButtonDisplay.propTypes = { color: string };

const HelpLink = () => {
  const handleClick = useCallback(() => {
    externalNavigate("https://help.flocknote.com/", "_blank");
  }, []);

  return (
    <WidthSetter>
      <ButtonWrapper
        onClick={handleClick}
        data-cy="MemberToolbar_HelpLink"
        DisplayComponent={ButtonDisplay}
      />
    </WidthSetter>
  );
};

const WidthSetter = styled.div`
  display: flex;
  justify-content: right;
  min-width: 40px;
`;

export { HelpLink };
